import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { validateQuestions, URLDerectionData} from '../../API/api';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Styles from'./UrlRedirectionStyles.module.css';
import MiniDrawer from "../../Component/newNavBar/newNavBar";
import { toast } from "react-toastify";
import { Home_PAGE_URL } from '../../Router/routerUrl';
import { saveShowpadTokenWithExpiry } from '../../utils';

export default function UrlRedirection() {
    const dispatch = useDispatch();
    const editorState = useSelector(state=>state.editor);
    
    const navigate = useNavigate();
    const {ownRecordsValue,updateOwnRecordsForEditor,recommendData, expertAnsweredFilter, updateAttachmentForEditor,updateSubmissionTypeForEditor,questionDataForEditor,updateAnswerTextForEditor,getSeekerAttachment,briefSourceChange} = bindActionCreators(Actions, dispatch)
    const {urlKey, urlValue,isAssigned}  = useParams();
    const errorToast = (message) => {
        return (
          <>
            <span style={{ fontSize: "12px" }}>{message}</span>
          </>
        );
      };
    const switchTabs = () =>{
      if(editorState.submissionType !== ''){
        navigate('/expertHome/open');
        return;
      }
      if(urlKey === 'assigntoother'){
        ownRecordsValue(false);
        updateOwnRecordsForEditor(false)
        navigate('/expertHome/open');
        return;
    }
    if(urlKey === 'token'){
        saveShowpadTokenWithExpiry(urlValue);
        window.close();
        briefSourceChange(['Showpad']);
        navigate('/seekerHome/brief');
        return;
    }
    if(urlKey === 'token2'){
        saveShowpadTokenWithExpiry(urlValue);
        window.close();
        return;
    }
        let payload = {};
        if(urlKey === 'answered'){
            payload.type = 'notification';
            payload.quesUuid = urlValue;
        }
        if(urlKey === 'requestupdateseeker'){
            payload.type = 'notification';
            payload.quesUuid = urlValue;
        }
        if(urlKey === 'anotherExpertAnswered'){
            payload.type = 'notification';
            payload.quesUuid = urlValue;
        }
        if(urlKey === 'shared'){
            payload.type = 'notification';
            payload.quesUuid = urlValue;
        }
        if(urlKey === 'open'){
          payload.type = 'notification';
          payload.quesUuid = urlValue;
      }
      if(urlKey === 'transferred'){
        expertAnsweredFilter([{"id": 17,"label": "Transferred","value": "transferred","description": "transfer"}]);
        navigate('/expertHome/answered');
        return;
      }
        validateQuestions(payload).then(res=>{
          if (res===undefined) return;
            if(urlKey === 'open'){
              if(res.data.data === ''){
                URLDerectionData(urlValue).then(res=>{
                  if (res===undefined) return;
                  if(res.data === undefined){
                    navigate('/expertHome/open');
                    return;
                  }
                  res.data.data.questionText = res.data.data.question;
                  res.data.data.questionPostedTimestamp = res.data.data.postedTimestamp;
                  updateAttachmentForEditor([]);
                  updateSubmissionTypeForEditor('answer');
                  questionDataForEditor(res.data.data);
                  updateAnswerTextForEditor('');
                  navigate('/expertHome/editor');
                  if(res.data.data.seekerAttachments && res.data.data.seekerAttachments !== null)
                  {
                  getSeekerAttachment(res.data.data.seekerAttachments)
                  }
                  // console.log(urlValue,'check url value')
                })
              }
              if(res.data.data === 'answered'){
                navigate('/expertHome/answered');
              }
              if(res.data.data === 'closed'){
                toast.error(errorToast('This question is not in your queue. Please check in Assigned to Others.'), {
                  position: toast.POSITION.TOP_RIGHT,
                }, 5000);
                navigate('/expertHome/open');
              }
              if(res.data.data === 'open'){
                let newpPayload ={...payload};
                newpPayload.type = 'open';
                newpPayload.isUrlRedirection = true;
                recommendData(newpPayload);
                navigate(`${Home_PAGE_URL}recommend`);
              }
              return;
            }else{
              if(res?.data?.data !== ''){
                let newpPayload ={...payload};
                newpPayload.isUrlRedirection = true;
                recommendData(newpPayload);
                navigate(`${Home_PAGE_URL}recommend`);
            }else{
                toast.error(errorToast('This question is not in your queue. Please check in Assigned to Others.'), {
                    position: toast.POSITION.TOP_RIGHT,
                  }, 5000);
                navigate(`${Home_PAGE_URL}`);
            }
            return;
            }
        })
    };
    useEffect(()=>{
        switchTabs();
    },[]);
  return (
    <>
        <div className={Styles.container}>
        <div style={{textAlign:'center'}}>
        <h1>Redirecting...</h1>
        <CircularProgress disableShrink sx={{color:'var(--medium_color_shade)'}} />
        </div>
    </div>
    </>
  )
}
